export const CACHE_KEY_ROADMAPS_OVERVIEW = "roadmaps-overview";
export const CACHE_KEY_ROADMAPS_BY_ID = "roadmaps-by-id";
export const CACHE_KEY_SOURCE_ID_LINKS = "source-id-links";
export const CACHE_KEY_ROADMAPS_ASSETS = "roadmaps-assets";

export const roadmapInitiativesTabsIds = {
  details: "details",
  tasks: "tasks",
  assets: "assets",
  costs: "costs",
};
export const roadmapInitiativesTabs = [
  { value: "details", label: "Details" },
  { value: "tasks", label: "Tasks" },
  { value: "assets", label: "Assets" },
  { value: "costs", label: "costs" },
];

export const initiativeStatusOptionIds = {
  upcoming: "Upcoming",
  inProgress: "In Progress",
  completed: "Completed",
};
export const initiativeStatusOptions = ["Upcoming", "In Progress", "Completed"];

export const taskStatusOptions = ["Planning", "Doing", "Done"];

export const roadmapDocumentTypeObject = {
  Attachment: 0,
  Note: 1,
  Hyperlink: 2,
  Image: 3,
};
